export default {
  wrapper: {
    display: "flex",
    width: "100vw",
    height: "100vh",
    alignItems: "center",
    backgroundColor: "#333",
  },
  loginBox: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  cardContainer: {
    width: "448px",
    minHeight: "271px",
    padding: "10px 25px",
    marginTop: "25px",
    borderRadius: "8px",
    overflow: "hidden",
    boxSizing: "border-box",
  },

  logo: {
    height: "101px",
  },

  inputLabel: {
    fontSize: "13px",
    letterSpacing: ".6px",
    fontWeight: "normal",
    color: "rgba(55, 65, 81, .9)",
  },
  input: {
    marginBottom: "13px",
    height: "42px",
  },

  inputCheck: {
    display: "flex",
    width: "15px",
    height: "15px",
    marginRight: "5px",
    marginBottom: "7px",
    border: "1px solid rgba(255, 20, 20, 1)",
    cursor: "pointer",
  },
  checkContainer: {
    display: "flex",
    alignItems: "center",
  },

  buttonContainer: {
    width: "100%",
    display: "flex",
    marginTop: "10px",
    justifyContent: "flex-end",
    boxSizing: "border-box",
  },
  submitBtn: {
    width: "82px",
    height: "33px",
    color: "#fff",
    fontSize: "11px",
    fontWeight: "normal",
    letterSpacing: "1.5px",
    borderRadius: "6px",
    backgroundColor: "rgba(31, 41, 55, 1)",
    borderColor: "rgba(31, 41, 55, 1)",
  },
};
